import classNames from 'classnames'
import { AnimatePresence, motion } from 'framer-motion'
import { JSX, useState } from 'react'

import { InventoryCard, InventoryType } from '@store'

import { InventoryCardItem } from '../card-item'
import styles from './InventoryRow.module.scss'

interface InventoryRowProps {
  onClick(card: InventoryCard): void
  handleDrop(card: InventoryCard): void
  items: InventoryCard[]
  type: InventoryType
}

export const InventoryRow = ({
  type,
  items,
  onClick,
  handleDrop,
}: InventoryRowProps): JSX.Element => {
  const [isDragging, setIsDragging] = useState(false)

  return (
    <div className={classNames(styles.inventoryRow)}>
      <div
        className={styles.row}
        style={{
          overflowX: isDragging ? 'hidden' : 'auto',
        }}
      >
        <AnimatePresence>
          {items.map((item) => (
            <motion.div
              key={item.id}
              initial={{ opacity: 1, scale: 1 }}
              exit={{ opacity: 0, width: 0, scale: 0.5 }}
              transition={{ duration: 0.3 }}
            >
              <InventoryCardItem
                type={type}
                card={item}
                onDragStart={() => setIsDragging(true)}
                onDragEnd={() => setIsDragging(false)}
                onClick={onClick}
                handleDrop={handleDrop}
              />
            </motion.div>
          ))}
        </AnimatePresence>
      </div>
    </div>
  )
}
